import { ActionIcon, Flex, LoadingOverlay, Paper, Tabs, Text } from "@mantine/core";
import { ArrowLeftIcon, FileTextIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import useSwr from "swr";
import { InvoiceApi } from "../../apis";
import { PageLayout } from "../../components/layout";
import { ClosedInvoice } from "./closed-invoice";
import { OpenedInvoice } from "./opened-invoice";

type IFileItem = {
  name: string;
  description: string;
  url: string;
};

type IFormData = {
  senderStaffId: string | undefined;
  senderBranchId: string | undefined;
  senderAccId: string | undefined;
  receiverBusinessId: string | undefined;
  paymentDate: Date | string | undefined;
  receiverBranchId: string | undefined;
  description: string | undefined;
  discountType: string | undefined;
  discountValue: number;
  shippingAmount: number;
  lines: any[];
  send: boolean;
  attachments: IFileItem[];
  refCode: string;
  orderSalesCode: string | null;
  purchaseSalesCode: string | null;
};

export const OurBuyerDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("invoice");
  const [tabKey, setTabKey] = useState<string>("1");

  const { data, isLoading } = useSwr<IFormData>(`/api/invoice/${params.id}`, async () => await InvoiceApi.get(`${params.id}`), {
    fallback: {},
  });

  const breadcrumbs = [
    { to: "/", label: t("breadcrumb.home") },
    { to: "/sales-invoice", label: t("breadcrumb.ourBuyer") },
    { label: t("ourBuyer.title") },
  ]

  return (
    <PageLayout
      title={
        <Flex gap={8} align="center">
          <ActionIcon onClick={() => navigate(-1)} variant="outline" size="sm" color="brand">
            <ArrowLeftIcon />
          </ActionIcon>
          <Text>{t("ourBuyer.title")}</Text>
        </Flex>
      }
      breadcrumb={breadcrumbs}>
      <Tabs
        onChange={(e: string | null) => {
          if (e) setTabKey(e);
        }}
        value={tabKey}>
        <Tabs.List>
          <Tabs.Tab color="brand" p={"xs"} value="1" leftSection={<FileTextIcon size={"1.2rem"} />}>
            {t("ourBuyer.openTab")}
          </Tabs.Tab>
          <Tabs.Tab color="brand" p={"xs"} value="2" leftSection={<FileTextIcon size={"1.2rem"} />}>
            {t("ourBuyer.closedTab")}
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="1" pt="xs" pos={"relative"} mih={"40vh"}>
          <Paper>{isLoading ? <LoadingOverlay visible /> : <OpenedInvoice data={data} />}</Paper>
        </Tabs.Panel>
        <Tabs.Panel value="2" pt="xs" pos={"relative"} mih={"40vh"}>
          {isLoading ? <LoadingOverlay visible /> : <ClosedInvoice data={data} />}
        </Tabs.Panel>
      </Tabs>
    </PageLayout>
  );
};
